import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { MY_ORGANIZATIONS_QUERY_KEY } from '../../organization/hooks/useGetMyOrganizations';

/**
 * Persist "this member finished (or skipped) the coach onboarding tour" on the
 * caller's own OrganizationMember row (MYS-132). Server-side so the tour does
 * not re-launch on a new browser or device; the uid-scoped localStorage flag
 * remains the immediate same-session guard.
 */
export const useCompleteCoachTour = () => {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (organizationId: string) =>
      client.fetchApi<{ coachTourCompletedAt: string | null }, {}>({
        endpoint: `organizations/${organizationId}/members/me/coach-tour-completed`,
        method: 'POST',
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MY_ORGANIZATIONS_QUERY_KEY });
    },
  });
};
